// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"23":"8f160e8a","148":"579b9e4e","228":"649ea4d1","299":"8fbb0c98","529":"7b6a523b","660":"fb8184e8","690":"b27bbedf","793":"5aa21b8d","842":"ae2f0c83","939":"5036c9d4","949":"3a7265c6","982":"b9f2a29f"}[chunkId] + ".chunk.js";
};